import React from 'react'
import Accordion from './Accordion'

function FaqTwo({ className }) {
  return (
    <>
            {/* Faq area Start */}
            <section id="faq" className={`rts-faq-area rts-section-gap ${className}`}>
                <div className="container">
                    <div className="section-title-area2">
                        <p
                            className="sub-title wow fadeInUp"
                            data-wow-delay=".3s"
                            data-wow-duration="2s"
                        >
                            FAQs
                        </p>
                        <h2
                            className="section-title wow fadeInUp"
                            data-wow-delay=".5s"
                            data-wow-duration="2s"
                        >
                            Got Questions? We’ve <br /> Got Answers!"
                        </h2>
                    </div>
                    <div
                        className="faq-inner wow fadeInUp"
                        data-wow-delay=".8s"
                        data-wow-duration="2s"
                    >
                        <Accordion />
                    </div>
                </div>
            </section>
            {/* Faq area End */}
        </>
  )
}

export default FaqTwo